import { NotificationProgrammatic as Notification } from 'buefy'

export default {
    install(Vue, options) {

        // Define your functions
        const toCurrency = (amount, data = {}) => {
            let decimal = data?.decimal === undefined ? true : data?.decimal;
            let symbol = data?.symbol === undefined ? '₦' : data?.symbol;
            
            let fromatted = Number((amount * 1) || 0).toLocaleString('en-US', {
                minimumFractionDigits:  decimal ? 2 : 0,
                maximumFractionDigits:  decimal ? 2 : 0
            })
            return `${symbol}${fromatted}`
        }

        const onFileChange = (value, callback) => {
            const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];

            if (value) {
                const fileExtension = value.type && value.type.split('/')[1].toLowerCase();
                if (allowedExtensions.includes(fileExtension)) {
                    callback && callback()
                    return true
                } else {
                        Notification.open({
                        duration: 4000,
                        message: 'Only image & pdf files (jpg, jpeg, png, pdf) are allowed.',
                        type: 'is-danger',
                    })
                }
            }
        }

        // Instance method
        Vue.prototype.$dataHandler = { 
            toCurrency, 
            onFileChange 
        };
    }
};

// function filterPics(data) {
//     return data.filter((val) => {
//         if (val.picture === null || '') {
//             val.picture = '/user.png';
//         }
//         return val;
//     })
// }

// function filterDirectPics(data) {
//     return data.filter((val) => {
//         if (val.Customer?.picture === null || '') {
//             val.Customer.picture = '/user.png';
//         }
//         return val;
//     })
// }

// function filterLoanFriendsPics(data) {
//     return data.filter((val) => {
//         if (val.Borrower?.picture === null || '') {
//             val.Borrower.picture = '/user.png';
//         }

//         if (val.Lender?.picture === null || '') {
//             val.Lender.picture = '/user.png';
//         }

//         if (val.Initiator?.picture === null || '') {
//             val.Initiator.picture = '/user.png';
//         }
//         return val;
//     })
// }

// function filterBrokenLoans(data) {
//     return data.filter((val) => {
//         if (val.NewLoan?.Customer?.picture === (null || '')) {
//             val.NewLoan.Customer.picture = '/user.png';
//         }

//         if (val.ParentLoan?.Customer?.picture === null || '') {
//             val.ParentLoan.Customer.picture = '/user.png';
//         }

//         return val;
//     })
// }

// function sliceData(data) {
//     return data.slice().sort((a, b) => new Date(b.updatedAt)- new Date(a.updatedAt));
// }

// function sliceStatusData(data, status) {
//     return sliceData(data).filter(val => val.status == status);
// }

// function sliceReasonStatusData(data, reason, status, newLoanStatus) {
//     let newData;
//     newData = sliceData(data).filter(val => val.reason == reason && val.status == status);

//     if (newLoanStatus) {
//         newData = newData.filter(item => item?.NewLoan?.status == newLoanStatus)
//     }

//     return newData
// }

// function sliceMultiStatusData(data, status) {
//     return sliceData(data).filter(val => status.includes(val.status));
// }

// function download(data, name) {
//     const fileUrl = window.URL.createObjectURL(new Blob([data]));

//     const link = document.createElement('a');
//     link.href = fileUrl;
//     link.setAttribute('download', name);
//     document.body.appendChild(link);
//     link.click();
// }

// function toFmtNumber(number, data = {}) {
//     let decimal = data?.decimal === undefined ? true : data?.decimal;
    
//     let fromatted = Number((number * 1) || 0).toLocaleString('en-US', {
//         minimumFractionDigits:  decimal ? 2 : 0,
//         maximumFractionDigits:  decimal ? 2 : 0
//     })

//     return fromatted
// }

// function capitalizeFirstLetter(params) {
//     let typeCheck = typeof params;
//     let data;

//     if (typeCheck == "string" && params) {
//         data =  params.charAt(0).toUpperCase() + params.slice(1);

//     } else if (typeCheck == "object" && params) {
//         data = params.map(word => word[0].toUpperCase() + word.slice(1));

//     } else { data = params }

//     return data;
// }

// function formatBalance(value) {
//     if (value >= 1000000000000) {
//         return toCurrency((value / 1000000000000), {decimal: false}) + 'T'; // Display trillions with 1 decimal
//     } else if (value >= 1000000000) {
//         return toCurrency((value / 1000000000), {decimal: false}) + 'B'; // Display billions with 1 decimal
//     } else if (value >= 1000000) {
//         return toCurrency((value / 1000000), {decimal: false}) + 'M'; // Display millions with 1 decimal
//     } else if (value >= 1000) {
//         return toCurrency((value / 1000), {decimal: false}) + 'K'; // Display thousands with 1 decimal
//     } else {
//         return toCurrency(value); // Display as is if less than 1000
//     }
// }

// function targetContributionType(type) {
//     if (type === "flex") {
//         return 'Flex purse'
//     } else if (type === 'fixed') {
//         return 'Goals';
//     }
//     return type
// }

// function removeEmptyKeys(data) {
//     return Object.entries(data).reduce((acc, [key, value]) => {
//         if (value) return { ...acc, [key]: value };
//         return { ...acc };
//     }, {});
// };

// function prefixAdder(item, toAdd, condition, conditionData) {
//     let returnData;

//     if (condition == 'length') {
//         let itemLength = item.toString().length
//         returnData = itemLength == conditionData ? `${toAdd}${item}` : item;

//     } else {
//         returnData = item;
//     }

//     return returnData;
// }

// function alphaSort (data, type) {
//     let sortedData;

//     if (!data || !type) {
//         sortedData = [];

//     } else {
//         sortedData = data?.sort((a, b) => {
//             let typeA = a[type]?.toLowerCase();
//             let typeB = b[type]?.toLowerCase();

//             if (typeA < typeB) { return -1 }
//             if (typeA > typeB) { return 1 }

//             return 0;
//         });
//     }

//     return sortedData;
// }

// function slug(event) {
//     // const checker = /^[a-z]+(_[a-z]+)*$/
//     const checker = /^[a-z_]*$/
//     if (!checker.test(event.key)) return event.preventDefault()
// }

// function nigerianStates() {
//     let states = [
//         "Abuja FCT",
//         "Abia",
//         "Adamawa",
//         "Anambra",
//         "Akwa Ibom",
//         "Bauchi",
//         "Bayelsa",
//         "Benue",
//         "Borno",
//         "Cross River",
//         "Delta",
//         "Ebonyi",
//         "Edo",
//         "Ekiti",
//         "Enugu",
//         "Gombe",
//         "Imo",
//         "Jigawa",
//         "Kaduna",
//         "Kano",
//         "Katsina",
//         "Kebbi",
//         "Kogi",
//         "Kwara",
//         "Lagos",
//         "Nasarawa",
//         "Niger",
//         "Ogun",
//         "Ondo",
//         "Osun",
//         "Oyo",
//         "Plateau",
//         "Rivers",
//         "Sokoto",
//         "Taraba",
//         "Yobe",
//         "Zamfara"
//     ]

//     return states
// }

// function copyText(value, field) {
//     try {
//         navigator.clipboard.writeText(value)
//         Notification.open({
//             duration: 4000,
//             message:  field + ' copied',
//             position: 'is-top-right',
//             type: 'is-primary'
//         })

//     } catch ($e) {
//         Notification.open({
//             duration: 4000,
//             message: 'Please try again',
//             position: 'is-top-right',
//             type: 'is-danger'
//         })
//     }
// }

// function convertObjectToQuery(params) {
//     const queryString = Object.entries(params)
//     .filter(([_, value]) => value !== '') // Exclude empty values
//     .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
//     .join('&');

//     return queryString
// }
